import { httpClient } from '@/services/http/http-client';

import {
  type AuthProfile,
  authProfileSchema,
  type ChangePasswordInput,
  type LoginResult,
  loginResultSchema,
  type UpdateProfileInput,
} from '../schemas/auth.schema';

/** The only place this feature talks to the network. */

export function login(identifier: string, password: string): Promise<LoginResult> {
  return httpClient.post('/auth/login', { identifier, password }, { schema: loginResultSchema });
}

export function getMe(signal?: AbortSignal): Promise<AuthProfile> {
  return httpClient.get('/auth/me', { schema: authProfileSchema, ...(signal ? { signal } : {}) });
}

export function updateProfile(input: UpdateProfileInput): Promise<AuthProfile> {
  return httpClient.patch('/auth/me', input, { schema: authProfileSchema });
}

export function changePassword(input: ChangePasswordInput): Promise<AuthProfile> {
  return httpClient.post('/auth/change-password', input, { schema: authProfileSchema });
}

export function logout(): Promise<void> {
  return httpClient.post('/auth/logout');
}
